import { Box, Button, Dialog, Grid2 as Grid, Slide, Typography } from "@mui/material";
import { acceptAllCookies, rejectAllCookies } from "../../utils/helper";
import { showDialog } from "../../redux/guest-slices/other.slice";
import { MANAGE_COOKIE } from "../../utils/keywords";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Cookies } from "react-cookie";

const Transition = function Transition(props) {
  return <Slide direction="up" {...props} />;
};

function Cookie() {
  const cookie = new Cookies();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const handleCookie = (action) => {
    if (action === "accept") {
      acceptAllCookies();
    } else if (action === "reject") {
      rejectAllCookies();
    } else {
      dispatch(showDialog(MANAGE_COOKIE));
    }
    setShow(false);
  };

  useEffect(() => {
    const isSaved = cookie.get("essentialCookies");
    !isSaved && setShow(true);

    // eslint-disable-next-line
  }, []);

  return (
    <Dialog
      fullWidth
      open={show}
      translate="yes"
      slots={{ transition: Transition }}
      sx={{
        ".MuiPaper-root": {
          my: 2,
          mx: "auto",
          width: { xs: "90%", sm: "60%", md: "40%" },
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          backgroundColor: "#fff",
          p: { xs: 2, sm: 3 },
        },
      }}
      maxWidth={false}
    >
      <Box>
        <Grid container spacing={{ xs: 1, md: 3 }}>

          <Grid size="grow">
            <Box>
              <Typography
                sx={{
                  mb: 1,
                  color: "text.primary",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                Your Privacy Matters
              </Typography>

              <Typography mb={2} color="text.secondary" fontSize="14px">
                InnerPal.com uses cookies to personalize content, provide social
                media features, and analyze our traffic. Some cookies are
                necessary, and others are optional. You can choose to accept or
                manage your preferences.
              </Typography>

              <Button
                sx={{
                  px: 0,
                  fontWeight: 600,
                  color: "primary.main",
                  textTransform: "none",
                  mb: 2,
                  ":hover": { textDecoration: "underline" },
                }}
                disableRipple
                to="/cookie-policy"
                component={Link}
                onClick={() => setShow(false)}
              >
                Learn More
              </Button>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 1.5,
                  flexWrap: "wrap",
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    borderRadius: "8px",
                    fontWeight: 500,
                  }}
                  onClick={() => handleCookie("accept")}
                >
                  Accept All
                </Button>

                <Button
                  color="error"
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    borderRadius: "8px",
                    fontWeight: 500,
                  }}
                  onClick={() => handleCookie("reject")}
                >
                  Reject All
                </Button>
                <Button
                  color="dark"
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    borderRadius: "8px",
                    fontWeight: 500,
                  }}
                  onClick={() => handleCookie(false)}
                >
                  Customize
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}

export default Cookie;
